export const CLEAN_FORM = 'clientes/clientes/clean-form';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';
export const SET_STATE_FORM = 'clientes/clientes/set-state-form';
export const UPDATE_FIELD_FILTER = 'clientes/clientes/update-field-filter';
export const RECEIVE_V_LIST = 'clientes/clientes/receive-v-list';
export const REQUEST_V_LIST = 'clientes/clientes/request-v-list';
export const ERROR_V_LIST = 'clientes/clientes/error-v-list';
export const SET_MASK = 'clientes/clientes/set-mask';
export const SET_ORDER = 'clientes/clientes/set-order';
export const RECEIVE_DATA= 'clientes/clientes/receibe-data';
export const UPDATE_TABLE_COLUMN= 'clientes/clientes/update-table-column';
export const SET_PAGE = 'clientes/clientes/set-page';
export const SET_PAGE_SIZE = 'clientes/clientes/set-page-size';
export const SET_SELECTED_ROW = 'clientes/clientes/set-selected-row';
export const UPDATE_FIELD_ENTITY = 'clientes/clientes/update-field-entity';
export const SET_ERROR = 'clientes/clientes/set-error';